import { CancelationService } from '@/common/services/cancelation/cancelation.service';
import { ConfigurationService } from '@/common/services/configuration/configuration.service';
import { ReservationDataService } from '@/common/services/details/details.service';
import { CancelationResponseInterface } from '@/core/domain/cancelation/models/cancelation.model';
import { DetailsInterface } from '@/core/domain/details/models/details.model';
import {
    Component,
    Input,
    OnInit,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import Swal from 'sweetalert2';

@Component({
    selector: 'fe-delivery-status',
    templateUrl: './delivery-status.component.html',
    styleUrls: ['./delivery-status.component.scss'],
})
export class DeliveryStatusComponent implements OnInit {
    reservationDetails: DetailsInterface | null = null;
    cancelationResponse: CancelationResponseInterface | null = null;

    @ViewChild('precheckTemplate') precheckTemplate!: TemplateRef<any>;

    constructor(
        private reservationDataService: ReservationDataService,
        private cancelationService: CancelationService,
        public readonly configuration: ConfigurationService,
    ) {}

    ngOnInit(): void {
        this.reservationDataService.getDetails().subscribe((details) => {
            this.reservationDetails = details;
        });
        this.cancelationService.cancelation$.subscribe((response) => {
            this.cancelationResponse = response;
        });
    }

    swal() {
        const precheckHtml = this.getTemplateHtml(this.precheckTemplate);

        Swal.fire({
            html: precheckHtml,
            customClass: {
                popup: 'custom-swal-popup-precheck',
            },
            showCloseButton: true,
            showConfirmButton: false,
        });
    }

    private getTemplateHtml(template: TemplateRef<any>): string {
        const container = document.createElement('div');
        const view = template.createEmbeddedView(null);

        view.detectChanges();
        container.appendChild(view.rootNodes[0]);
        return container.innerHTML;
    }
}
